import { sessaoFetchLoading, sessaoFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function getCobrancas (dados) {
  return sessaoFetchLoading(`consig`, `/cobrancas/ListarTodosPaginadoQueryEnvelopado?` + serialize(dados), 'GET')
}
export async function getTodasCobrancasSemTotalizador (dados) {
  return sessaoFetchLoading(`consig`, `/cobrancas/ListarTodosComParametros?` + serialize(dados), 'GET')
}
export async function getTodasCobrancasComTotalizador (dados) {
  return sessaoFetchLoading(`consig`, `/cobrancas/ListarTodosComParametrosComTotalizador?` + serialize(dados), 'GET')
}
export async function getCalculaBonificacao (dados) {
  return sessaoFetch(`consig`, `/cobrancas/CalcularBonificacao?` + serialize(dados), 'GET')
}
export async function salvaBonificacao (dados) {
  return sessaoFetchLoading(`consig`, `/cobrancas/CriarBonificacao`, 'POST', dados)
}
export async function ExcluirCobranca (id) {
  return sessaoFetchLoading(`consig`, `/cobrancas/${id}`, 'DELETE')
}
export async function verificarCobranca (referencia) {
  return sessaoFetch(`consig`, `/cobrancas/verificarCobranca`, 'PATCH', referencia)
}
export async function pagarCobranca (referencia) {
  return sessaoFetchLoading(`consig`, `/cobrancas/PagarCobranca`, 'PATCH', referencia)
}



// WEBPACK FOOTER //
// ./src/api/cobrancas.js